import { NgModule } from '@angular/core';
import { LightRaysBackgroundComponent } from './light-rays-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        LightRaysBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        LightRaysBackgroundComponent
    ]
})
export class NcLightRaysBackgroundModule { }